@if (loading) {
<div class="page-loading">
  <span>
    <span></span>
  </span>
</div>
} @if (listing) {
<pc-bambuser-playlist />
<div class="product-contain">
  @if (listing && listing.ProductImage) {
  <image-carousel
    [items]="listing.ProductImage"
    [scheme]="listing.colour_scheme"
    [companyId]="listing.company_id"
  ></image-carousel>
  }
  <section class="container">
    <h1>{{ listing?.title }}</h1>
    @if (listing?.features) {
    <product-price
      [listing]="listing"
      [scheme]="listing.colour_scheme"
    ></product-price>
    } @if (listing.ProductExtraInfo) {
    <extra-info
      [scheme]="listing.colour_scheme"
      type="payment"
      [productInfo]="listing.ProductExtraInfo"
    >
    </extra-info>
    } @if (isUrl) {
    <div>
      <div>
        <a [href]="listing.features.external_url" target="_blank">
          <button>
            <span class="fa fa-external-link"></span>
            {{ listing.features.button_text || 'Apply Online' }}
          </button>
        </a>
      </div>
    </div>
    } @if (iframe?.url) {
    <div>
      <button (click)="showTheIssue()">{{ iframe.title }}</button>
    </div>
    } @if (isFilmology) {
    <div>
      <form
        action="https://www.cinemabenefits.co.uk/johnlewis/index.php"
        method="post"
        name="FV_form"
        enctype="multipart/form-data"
      >
        <input
          type="hidden"
          name="fv_value"
          id="fv_value"
          value="KSgdq29d7jw8v6ds1"
        />
        <input
          class="button"
          type="submit"
          id="submit"
          value="Click here to buy cinema tickets"
          href="
            https://www.cinemabenefits.co.uk/johnlewis/index.php
          "
        />
      </form>
    </div>
    } @if (isTicket) {
    <product-tickets
      [scheme]="listing.colour_scheme"
      [product]="listing"
    ></product-tickets>
    } @if (isProduct) {
    <product-products
      [scheme]="listing.colour_scheme"
      [product]="listing"
    ></product-products>
    }
  </section>
  <div class="container product-content">
    <section
      class="product-description"
      [innerHtml]="listing.description"
    ></section>
    @if (listing.ProductExtraInfo) {
    <extra-info
      [scheme]="listing.colour_scheme"
      type="product"
      [productInfo]="listing.ProductExtraInfo"
    >
    </extra-info>
    } @if (relatedContent && relatedContent.length > 0) {
    <div class="row clearfix max-width" style="margin-top: 20px">
      <div class="small-12 columns">
        <div>
          <h2>Related Pages</h2>
        </div>
      </div>
    </div>
    } @if (relatedContent && relatedContent.length > 0) {
    <cards-carousel
      [scheme]="listing.colour_scheme"
      class="no-duplicate"
      overflow-scroll="true"
      [items]="relatedContent"
    ></cards-carousel>
    }
  </div>
</div>
}
